import { ServiceCookies } from '@services/ServiceCookies';
import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';
import { FeedbackRequestProps, RegistrationForCorporateServicesProps } from './Api.dto';
import { TypePromisePushSMSMapShop, TypePromiseSignUpForGreatDeals } from './TypePromise';

class ServiceNotification {
  async pushSMSMapShop(phone: string, shopName: string, url: string, captchaTokenGoogle: string): Promise<TypePromisePushSMSMapShop> {
    const query = { template: 'map_sms', phone, shop: shopName, data: url, adapter: 'beeline', captchaTokenGoogle };
    return MyAxios.post('/api/sms/sendByTemplate', query).then(handleResponse).catch(handleError);
  }

  async signUpForGreatDeals(email: string, captchaToken: string): Promise<TypePromiseSignUpForGreatDeals> {
    const query = { email, uuid: ServiceCookies.mindboxDeviceUUID, 'smart-token': captchaToken };
    return MyAxios.post('/api/misc-service/mindboxSubscriber', query).then(handleResponse).catch(handleError);
  }

  async registrationForCorporateServices(query: RegistrationForCorporateServicesProps): Promise<TypePromiseSignUpForGreatDeals> {
    return MyAxios.post('/api/email/sendEmailRecordForCorporateServices', query).then(handleResponse).catch(handleError);
  }

  async postFeedbackRequest(query: FeedbackRequestProps) {
    return MyAxios.post('/api/header/callback', query).then(handleResponse).catch(handleError);
  }
}

const serviceNotificationInstance = new ServiceNotification();

export default serviceNotificationInstance;
